{
  "futuresTitle": "EXALT Vadeli İşlemler",
  "futuresSubtitle": "Gerçek Zamanlı Vadeli İşlem Paneli",
  "liveFuturesMarket": "Canlı Vadeli İşlem Piyasası",
  "perpetualFutures": "Perpetual Vadeli İşlemler",
  "buyLong": "Al / Long",
  "sellShort": "Sat / Short",
  "cross": "Cross",
  "isolated": "İzole",
  "market": "Piyasa",
  "limit": "Limit",
  "amount": "Miktar",
  "price": "Fiyat",
  "cost": "Maliyet",
  "available": "Kullanılabilir",
  "margin": "Marj",
  "marginMode": "Marj Modu",
  "leverage": "Kaldıraç",
  "orderType": "Emir Türü",
  "entryPrice": "Giriş Fiyatı",
  "markPrice": "Mark Fiyatı",
  "liquidation": "Likidasyon",
  "takeProfit": "Kâr Al",
  "stopLoss": "Zarar Durdur",
  "tpPrice": "TP Fiyatı",
  "slPrice": "SL Fiyatı",
  "reduceOnly": "Sadece Azalt",
  "positions": "Pozisyonlar",
  "openPositions": "Açık Pozisyonlar",
  "positionHistory": "Pozisyon Geçmişi",
  "openOrders": "Açık Emirler",
  "orderBook": "Emir Defteri",
  "funding": "Fonlama",
  "fundingRate": "Fonlama Oranı",
  "riskLevel": "Risk Seviyesi",
  "quoteCurrency": "Kote Para Birimi",
  "bots": "Botlar",
  "futuresSettings": "Vadeli İşlem Ayarları",
  "normalCandles": "Normal Mumlar",
  "smoothCandles": "Yumuşatılmış Mumlar",
  "volatileCandles": "Volatil Mumlar",
  "lowVolatility": "Düşük Oynaklık",
  "normalVolatility": "Normal Oynaklık",
  "highVolatility": "Yüksek Oynaklık",
  "zoomSmall": "Küçük Yakınlaştırma",
  "zoomMedium": "Orta Yakınlaştırma",
  "zoomLarge": "Büyük Yakınlaştırma",
  "tradingViewChart": "TradingView Grafiği",
  "mobileFuturesChart": "Mobil Vadeli İşlem Grafiği",
  "searchMarket": "Piyasa Ara...",
  "searchPair": "Parite Ara...",
  "noOpenPositions": "Açık pozisyon yok.",
  "noClosedPositions": "Kapatılmış pozisyon yok.",
  "openLong": "Long Aç",
  "openShort": "Short Aç",
  "closePosition": "Pozisyonu Kapat",
  "processing": "İşleniyor...",
  "loading": "Yükleniyor...",
  "importantNotice": "Önemli Uyarı",
  "priceMovementWarning": "Normal işlem saatleri dışında sınırlı fiyat hareketi ve azalmış likidite olabilir.",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın."
}